import React, { Component } from "react";
import HistoricSocialSecurityForm from "../HistoricSocialSecurityForm/HistoricSocialSecurityForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : OvertimePage
Description : Componente que contienen el formulario de la pantalla Overtime
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente OvertimeForm
================================================================================ */
class HistoricSocialSecurityPage extends Component{
    render(){
        return(
            <div>                    
                <HistoricSocialSecurityForm/>
            </div>
        )   
    }
}

export default HistoricSocialSecurityPage;